/**
 * @typedef {object} ISubscriptionResource
 * @property {() => ng.resource.IResource<import('types/api').V2.FetchManagementSubscriptionStrategy.Response>} fetchManagementStrategy
 */

import { resourceHeaders } from './resource-actions.factory';

export default [
  '$resource',
  SubscriptionResource,
];

/**
* @return {ISubscriptionResource}
*/
export function SubscriptionResource($resource) {

  return $resource(
    '/api/v2/subscriptions',
    {}, {
      'fetchManagementStrategy': {
        url: '/api/v2/subscriptions/manage',
        method: 'POST',
        headers: resourceHeaders.get
      },
    });
}
